import react, { useState } from "react";
import Header from "./Header";

const HeaderNavBar = () => {
  const [showNames, setShowNames] = useState(false);
  return (
    <>
      <aside className={`${showNames ? "w-[200px]" : 'w-[80px]'} hidden xl:h-full lg:h-full h-10 header ms-3 mt-[14px] shrink-0 transition-all duration-300 ease-in-out bg-[#EBF5FF] shadow-lg lg:flex flex-col items-center rounded-[20px] overflow-hidden relative`}
      >
        <div className="flex h-full min-h-0 w-full flex-col space-y-6">
          <Header setShowNames={setShowNames} showNames={showNames} />
        </div>
      </aside>
    </>
  )

}

export default HeaderNavBar;
